module.exports = __webpack_public_path__ + "img/logo_scientific.bebad772.png";